import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    tableRow: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row"
    },
    colActions: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        width: 40
    },
    avatarPlaceholder: {
        justifyContent: "center",
        alignItems: "center",
        height: 40,
        width: 40
    },
    companyTitleContainer: {
        justifyContent: "center",
        flex: 1
    },
    colContact: {
        justifyContent: "center",
        flex: 1.5
    },
    colCompany: {
        flexDirection: "row",
        alignItems: "center",
        flex: 2
    },
    colSector: {
        alignItems: "center",
        flexDirection: "row",
        flex: 1.5
    },
    avatarText: {
        fontWeight: "600"
    },
    contactPhoneText: {},
    avatarImage: {
        height: 40,
        width: 40
    }
});

export default stylesheet;
